import React from "react";
import BreadCrumb from "../molecules/BreadCrumb";
import PageTitle from "../molecules/PageTitle";
import SubNav from "../molecules/SubNav";
import styled from "styled-components";

const Container = styled.div`
    margin-bottom: 40px;
`;

const PageHeader = ({bTitle, subTitle, detail, desc, list, link, top, onClick }) => {
    return (
        <Container>
            {top && list && <SubNav list={list} link={link}/>}
            <BreadCrumb title={bTitle} subTitle={subTitle} detail={detail}/>
            <PageTitle title={detail} desc={desc}/>
            {!top && list && <SubNav list={list} link={link}
                                             onClick={onClick} />}
        </Container>
    );
};

export default PageHeader;
